export const RoutePath = {
  indexRoute: '/',
  bookingRoute: '/booking',
  paypalReturn: '/booking/paypal-return',
  paypalSuccess: '/booking/paypal-success',
  PayPalCancel: '/booking/paypal-cancel',
  loginRoute: '/login',
  resetPasswordRoute: '/reset-password',
  adminRoute: '/admin',
  deleteAppointmentRoute: '/booking/delete-appointment',
  paymentLinkRoute: '/booking/payment',
  deleteSuccessRoute: '/booking/delete-success',
  paymentSuccessRoute: '/booking/payment-success',
  staff: {
    index: '/staff',
    patientList: {
      index: 'patient',
      patientDetails: 'details',
      questionnaire: 'questionnaire',
    },
    calendar: {
      index: 'calendar',
      confirmBooking: 'confirm-booking',
      rescheduleBooking: 'reschedule-booking',
      appointments: 'appointments',
      pendingRequests: 'pending-requests',
      newPatientRequests: 'new-patient-requests',
      bookingDetails: 'booking-details',
      editBooking: 'edit-booking',
    },
    finance: {
      index: 'finance',
      paymentList: 'payment-list',
      payments: 'payments',
      paymentDetails: 'payments/:id',
      paymentSuccess: 'payments/:id/payment-success',
      insuranceClaims: 'insurance-claims-list',
      insuranceClaimDetails: 'insurance-claims/:id',
      invoiceDetails: 'payments/:id/invoice',
      insuranceClaimInvoiceDetails: 'insurance-claims/:id/invoice',
      financialRecord: 'financial-record',
      dashboard: {
        index: 'dashboard',
        pricingList: 'pricing-list',
      },
    },
    notification: 'notification',
  },
  patient: {
    index: '/patient',
    login: 'login',
    register: 'register',
    forgotPassword: 'forgot-password',
    otpVerification: 'email-verification',
    createPassword: 'create-password',
    onBoarding: {
      index: 'onboarding',
    },
  },
} as const;

export const PricingListRoutePaths = {
  consultation: 'consultation',
  diagnostic: 'diagnostic',
  refractive: 'refractive',
  retinal: 'retinal',
  oculoplastics: 'oculoplastics',
  corneal: 'corneal',
  glaucoma: 'glaucoma',
  addons: 'addons',
} as const;
